import { MdAdd } from "react-icons/md";
import { GoArrowLeft } from "react-icons/go";
import { Navigate, useNavigate } from "react-router-dom";
import { GoChevronDown } from "react-icons/go";
import anonymous from "../../assets/images/anonymous.jpg.webp"
import { GoArrowUp } from "react-icons/go";
import { FaHeart } from "react-icons/fa6";
import { FaComment } from "react-icons/fa";
import { GoArrowDown } from "react-icons/go";
import BTC from '../../assets/images/EURO.png'
import { SafeAreaContext } from "../../App";
import { useContext,useEffect } from "react";



export default function LastSignal(){
    //safArea for Pwa////////
const { setSafeAreaColor } = useContext(SafeAreaContext);

useEffect(() => {
    setSafeAreaColor({ background: "#FFFFFF" });
}, []);
////////////////////////

    const navigation=useNavigate()
    function onReturnBtnClick(){
        navigation('/signals')
    }
    function onAddSignalBtnClick(){
        navigation('/createSignal')
    }
    return(
        <>
    

        <div className=" h-[100vh] bg-light   overflow-y-scroll  w-full ">
            {/* header */}
     

       
                <div className="flex z-20 flex-row justify-between items-center h-[77px] w-full fixed top-0 bg-white text-gray-900 p-4 border-b-1 border-[#E5E7EB] shadow-md">
                 
                    <div className="items-center text-center flex flex-row gap-2  justify-center ">
                        <GoArrowLeft  className="text-gray-900 size-6 stroke-[1]" onClick={onReturnBtnClick}  ></GoArrowLeft>
                        <p className="font-extrabold  text-gray-900 text-xl ">Signals</p>
                    
                    </div>


                    <button onClick={onAddSignalBtnClick} className="basis-1/2 min-h-full flex flex-row justify-end gap-2 items-center text-center ">
                        <MdAdd className="text-gray-900 size-6"></MdAdd>
                    </button>
                
                </div>
      
            {/* header */}

            {/* body */}

      
            <div className=" h-max  px-4 py-[calc(77px+1rem)]  w-full flex flex-col gap-4 overflow-y-scroll ">
                  {/* header of body */}
                <div className="flex flex-row w-full gap-2 justify-center items-center h-[40px]">
                    <button className="basis-1/6 h-full bg-white border-2 border-primary rounded-[8px] text-primary text-[14px]">ALL</button>
                    <button className="basis-1/5 h-full bg-gradient-to-r from-primary to-primary-light border-1 border-[#E5E7EB] rounded-[8px] text-white text-[14px]">رایگان</button>
                    <button className="basis-1/3 h-full  bg-gradient-to-r from-primary to-primary-light border-1 border-[#E5E7EB] rounded-[8px] text-white text-[14px]">My Signals</button>
                    <button className="basis-1/3 h-full  bg-gradient-to-r from-primary to-primary-light border-1 border-[#E5E7EB] rounded-[8px] text-white text-[14px] flex flex-row items-center justify-center gap-1">
                        <p>Traders</p>
                        <GoChevronDown className="size-[14px] stroke-[1]"></GoChevronDown>
                    </button>
                </div>
            {/* header of body */}

            {/* cards fro normal models */}
                    <div className=" w-full min-h-max max-h-[700px]  bg-white border-1 border-[#E5E7EB] rounded-[12px] shadow-lg">

                        {/* header of cards modal */}
                        <div className="flex flex-row justify-between p-2 h-[70px] bg-[#F9FAFB] rounded-lg">

                            <div className="flex flex-row basis-1/2 justify-center gap-2 items-center">
                                <div className="w-[48px] h-[48px] relative rounded-full flex items-center justify-center flex-row">
                                        
                                        <img src={anonymous} className="rounded-full w-full"></img>
                                </div>
                                <div className="items-center max-w-[105px]">
                                    <p className="block truncate leading-[24px] text-[16px]  font-bold">Reza Akbari</p>
                                    <p className="block truncate text-[12px] leading-[16px] text-[#808080] ">30 minutes ago</p>
                                </div>
                            </div>

                        </div>
                        {/* header of cards modal */}

                        {/* body and desc of cards */}
                        <div className="flex flex-col p-2 justify-center items-center divide-x-2 divide-[#E5E7EB]">
                            <div className="flex flex-row w-full max-h-max mx-2 justify-between items-center p-1">

                                    <div className="flex flex-row gap-1 justify-center">

                                        <div className=" w-[64px] h-[64px]">
                                            <img className="h-full w-full object-contain" src={BTC}></img>
                                        </div>
                                        <div className="flex flex-col  items-center justify-end basis-2/3">
                                            <p className="text-[18px] leading-[28px] font-bold truncate">EUR/USD</p>
                                            <p className="text-[12px] leading-[16px] truncate text-[#808080]">by Ahmad Rezaei</p>
                                        </div>

                                    </div>

                                    <div className="rounded-[9999px] max-w-max h-[25px] p-4 bg-[#DCFCE7] flex flex-row justify-center gap-1 items-center">
                                        <GoArrowUp className="text-[#166534] font-bold  size-[14px] stroke-[2]"></GoArrowUp>
                                        <p className="text-[#166534] text-center text-[14px]  font-bold">BUY</p>
                                        
                                    </div>
                                        
                            </div>
                            

                            
                        </div>
                        {/* body and desc of cards */}

                    </div>
            {/* cards fro normal models */}       
                
            </div>
            {/* body */}
        </div>
        </>
    )
}